var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { promoteShiftsFunctionDef, } from '../../../../../backend/features/shift/shared';
import { NoShifts } from '../../../../../ui/components/NoShifts';
import { PageToolbar } from '../../../../../ui/components/PageToolbar';
import { PendingRequests } from '../../../../../ui/components/PendingRequests';
import { promoteShiftsDialog } from '../../../../../ui/components/PromoteShiftsDialog';
import { ShiftRemainingTime } from '../../../../../ui/components/ShiftRemainingTime';
import { Slots } from '../../../../../ui/components/Slots';
import { Shift } from '../../../../../ui/features/mission-details/components/Shift';
import { useAuthorizeManageMission } from '../../../../../ui/features/mission/hooks/useAuthorizeManageMission';
import { useMission } from '../../../../../ui/features/mission/hooks/useMission';
import { ParticipantDetails } from '../../../../../ui/features/participant-details';
import { ShiftDetailsAdminActions } from '../../../../../ui/features/shift-details/components/shift-details-actions';
import { ShiftDetailsTablesAdmin } from '../../../../../ui/features/shift-details/components/shift-details-tables';
import { ParticipantsAvailabilityProvider } from '../../../../../ui/features/shift-details/contexts/ParticipantsAvailabilityContext';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { MissionContext } from '../../../../../ui/providers';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import AddIcon from '@mui/icons-material/Add';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import { Box, Button, Divider, Typography, useMediaQuery } from '@mui/material';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
export const UpcomingShiftsAdmin = ({ shifts, onFetchShifts, missionId, missionStatus, missionOrganizationSharing, }) => {
    const { t } = useMissionsTranslation();
    const navigate = useNavigate();
    const navigationContext = React.useContext(NavigationContext);
    const promoteShiftsPlatformFn = useTypedPlatformFunction(promoteShiftsFunctionDef);
    const userState = useUserState();
    const onPromoteShift = (missionId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            return yield promoteShiftsPlatformFn({ missionId });
        }
        catch (error) {
            return handleErrorDialog(error);
        }
    });
    const { onParticipantSelect } = React.useContext(MissionContext);
    const upLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));
    const handleAddNewShift = () => {
        navigationContext.navigate(() => navigate('new-shift'));
    };
    const { mission, mobilizeMission, closeMission, fetchMission } = useMission({ missionId });
    const handleEditShift = (shiftId) => {
        navigationContext.navigate(() => {
            navigate(`edit-shift/${shiftId}`);
        });
    };
    const handleDuplicateShift = (shiftId) => {
        navigationContext.navigate(() => {
            navigate(`duplicate-shift/${shiftId}`);
        });
    };
    const handleMobilizeMission = () => {
        promoteShiftsDialog(t('missions.mobilizeMissionDialog.title'), t('missions.mobilizeMissionDialog.description'), t('missions.mobilizeMissionDialog.confirmButtonText'), () => __awaiter(void 0, void 0, void 0, function* () {
            yield mobilizeMission();
            yield onFetchShifts();
        }));
    };
    const handlePromoteShift = () => {
        promoteShiftsDialog(t('shifts.promoteShiftsDialog.title'), t('shifts.promoteShiftsDialog.description'), t('shifts.promoteShiftsDialog.confirmButtonText'), () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield onPromoteShift(missionId);
                yield fetchMission();
                yield onFetchShifts();
            }
            catch (e) {
                handleErrorDialog(e);
            }
        }), mission === null || mission === void 0 ? void 0 : mission.columns.promotedAt);
    };
    const handleMissionClose = () => {
        showConfirmDialog({
            title: t('missions.closeMissionConfirmationTitle'),
            confirmLabel: t('missions.closeMissionConfirmationAccept'),
            cancelLabel: t('common.cancel'),
            content: React.createElement(Typography, { variant: 'body1' }, t('missions.closeMissionConfirmationContent')),
            onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                yield closeMission();
                yield onFetchShifts();
            }),
        });
    };
    if (shifts.length === 0) {
        return (React.createElement(NoShifts, { description: t('missions.noUpcomingShiftsForMission'), onCreateNewShift: handleAddNewShift, onMissionClose: handleMissionClose }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(PageToolbar, { title: t('shifts.upcomingShifts'), showTitle: missionStatus !== 'complete', count: shifts.length }, missionStatus !== 'complete' && (React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: { xs: 'column-reverse', lg: 'row' },
                gap: 2,
                ml: { lg: 'auto' },
                width: { xs: '100%', lg: 'unset' },
            } },
            React.createElement(Box, { sx: { display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' }, gap: 2 } },
                React.createElement(Button, { variant: 'outlined', size: 'large', onClick: handlePromoteShift, disabled: missionStatus === 'draft', startIcon: React.createElement(CampaignOutlinedIcon, null), "data-test": 'promote-shifts-button', sx: { width: { xs: '100%', lg: 'unset' } } }, t('shifts.promoteShifts')),
                React.createElement(Button, { variant: missionStatus === 'draft' ? 'outlined' : 'contained', size: 'large', onClick: handleAddNewShift, startIcon: React.createElement(AddIcon, null), "data-test": 'add-new-shift-button', sx: { width: { xs: '100%', lg: 'unset' } } }, t('shifts.addShift'))),
            missionStatus === 'draft' && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { orientation: upLgScreen ? 'vertical' : 'horizontal', flexItem: true }),
                React.createElement(Button, { variant: 'contained', size: 'large', onClick: handleMobilizeMission, startIcon: React.createElement(RocketLaunchOutlinedIcon, null), "data-test": 'mobilize-mission-button' }, t('missions.mobilizeMission'))))))),
        React.createElement(Box, { display: 'flex', flexDirection: 'column', sx: { gap: 2, pt: 2 }, role: 'list' },
            React.createElement(ParticipantsAvailabilityProvider, null, shifts.map((shift, index) => (React.createElement(ShiftForUpcomingShiftsAdmin, { key: shift.id, indexInList: index, shift: shift, missionStatus: missionStatus, missionId: missionId, missionOrganizationSharing: missionOrganizationSharing, userState: userState, onPromoteShift: handlePromoteShift, onParticipantSelect: onParticipantSelect, onFetchShifts: onFetchShifts, onDuplicateShift: handleDuplicateShift, onEditShift: handleEditShift }))))),
        React.createElement(ParticipantDetails, null)));
};
const ShiftForUpcomingShiftsAdmin = ({ shift, onDuplicateShift, onEditShift, missionStatus, missionId, missionOrganizationSharing, onPromoteShift, onParticipantSelect, onFetchShifts, indexInList, }) => {
    const { authorizeManageMission } = useAuthorizeManageMission();
    const renderParticipantsTable = useCallback((participants, fetchParticipants) => (React.createElement(ShiftDetailsTablesAdmin, { shift: shift, participants: participants, missionStatus: missionStatus, missionId: missionId, onPromoteShift: onPromoteShift, onParticipantSelect: onParticipantSelect, onReloadShifts: onFetchShifts, onReloadParticipants: fetchParticipants })), [shift, missionStatus, missionId, onPromoteShift, onParticipantSelect, onFetchShifts]);
    return (React.createElement(Shift, { shift: shift, location: 'missions', indexInList: indexInList, allowMissionChange: authorizeManageMission(shift.missionTypeId, missionOrganizationSharing), renderParticipantsTable: renderParticipantsTable, showShiftDetailsCardToggle: false, analyticsComponent: React.createElement(Box, { sx: { display: 'flex', gap: 2, width: '100%' } },
            React.createElement(Slots, { total: shift.columns.totalParticipantSlots, totalApproved: shift.analytics.totalApprovedParticipants }),
            React.createElement(PendingRequests, { totalPendingParticipants: shift.analytics.totalPendingParticipants })), actionsComponent: React.createElement(Box, { sx: {
                display: 'flex',
                justifyContent: { xs: 'space-between', lg: 'flex-end' },
                alignItems: 'center',
                ml: { xs: 'unset', lg: 'auto' },
                gap: 2,
                width: { xs: '100%', lg: 'auto' },
            } },
            React.createElement(ShiftRemainingTime, { startTime: shift.columns.startTime }),
            React.createElement(Box, { sx: { display: 'flex' } },
                React.createElement(ShiftDetailsAdminActions, { shiftId: shift.id, onDuplicateShift: onDuplicateShift, onEditShift: onEditShift, missionStatus: missionStatus }))) }));
};
